import {Component, Input} from '@angular/core';
import {DataProvider} from "../../providers/data/data";
import {Route} from "../../models/data.model";

@Component({
  selector: 'route-preview',
  templateUrl: 'route-preview.html'
})
export class RoutePreviewComponent {

  @Input('siteId') siteId: number;
  @Input('sectorId') sectorId: number;
  @Input('routeId') routeId: number;

  constructor(private data: DataProvider) {
  }

  protected getRoute(): Route {
    return this.data.getRoute(this.siteId, this.sectorId, this.routeId);
  }
}



// WEBPACK FOOTER //
// ./src/components/route-preview/route-preview.ts